import { Router } from 'framework7/types';
import React, { FC } from 'react';
import { SelfScanResult } from './SelfScanResult/SelfScanResult';

type SelfScanResultPageProps = {
  f7router: Router.Router;
};

export const SelfScanResultPage: FC<SelfScanResultPageProps> = ({
  f7router,
}) => {
  return <SelfScanResult f7router={f7router} />;
};
